/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { StoreDataCache, findCache, saveCache } from '@/store/cache';
import { ActionType, StoreActionEnv, finalizeAction } from '@/store/actions';
import { SecretPostFilter } from '@/api/types/secret';

export interface StoreSecretFilterInfoState {
  cache: StoreDataCache<SecretPostFilter>[];
  maxCache: number;
}

export default {
  namespaced: true,
  state: {
    cache: [],
    maxCache: 20,
  },
  getters: {},
  actions: {
    [SECRET.GET_FILTER_INFO](
      { commit, state }: StoreActionEnv<StoreSecretFilterInfoState>,
      { action: rawAction, filter = 'all', async, silent }: { action: ActionType; filter: string; async: boolean; silent: boolean },
    ) {
      const cache = findCache(state.cache, filter);
      const action = finalizeAction(rawAction, cache);
      if (action) {
        const promise = new Promise((resolve, reject) => {
          api.getPostFilterInfo(filter, silent).then((res) => {
            commit(SECRET.GET_FILTER_INFO, {
              filter,
              info: res.data,
            });
            resolve(res.data);
          }).catch(reject);
        });
        if (!cache || !async) {
          return promise;
        }
      }
      return Promise.resolve(cache);
    },
  },
  mutations: {
    [SECRET.GET_FILTER_INFO](state, { filter, info }) {
      saveCache(state.cache, filter, info, state.maxCache);
    },
  },
};
